import styles from './TwitterUserLink.module.css'
import { getTwitterUserUrl } from 'utilities/twitter'

type UserLinkProps = {
  username: string,
  children: React.ReactNode,
}

const TwitterUserLink = ({ username, children }: UserLinkProps) =>
  <a role='button' className={styles.link} href={getTwitterUserUrl(username)} target='_out'>{ children }</a>

export default TwitterUserLink
